import actions from '@/store/modules/platform-notifications/actions.js'
import cloneDeep from 'lodash/cloneDeep'
import state from '@/store/modules/platform-notifications/state.js'
import mutations from '@/store/modules/platform-notifications/mutations.js'
import getters from '@/store/modules/platform-notifications/getters.js'

export default {
  actions,
  state: cloneDeep(state),
  mutations,
  getters,
}
